var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Mall'),_c('Business'),_c('Guidelines'),_c('Service'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }